import { Flex, Text } from '@mantine/core';
import { SelectCurrencyMenu } from './SelectCurrencyMenu';
import { SelectTokenMenu } from './SelectTokenMenu';
export const PaySelect: React.FC = () => {
  return <Flex direction={{
    base: 'column',
    sm: 'row'
  }} gap={10} align="center">
      <SelectCurrencyMenu />
      <Text c="var(--text-purple)" lh="5px">
        {'='}
      </Text>
      <SelectTokenMenu />
    </Flex>;
};